import { isNullOrUndefined } from 'helpers/general';
import { DataWithPagination, Pagination } from 'types';

export const getMartePagination = (data: DataWithPagination | null): Pagination | undefined => {
  if (!data) return undefined;
  const { page, pageCount: totalPages, objectCount, pageSize } = data;

  const totalItems = isNullOrUndefined(objectCount) ? Infinity : objectCount; // TODO Comment temporary(while fixing a problem in the api)

  if (!page || !totalPages || !pageSize) return undefined;

  return {
    page,
    totalPages,
    totalItems,
    pageSize,
  };
};

export const parsePaginatedResponse = <T = any>(
  response: DataWithPagination<any> | null
): {
  data: Array<T> | null;
  pagination: Pagination | undefined;
} => {
  return {
    pagination: getMartePagination(response),
    data: response?.pageObjects || null,
  };
};

export const getIndexFromPagination = (index: number, pagination: Pagination): number => {
  const { page, pageSize } = pagination;

  return (page - 1) * pageSize + index;
};
